(function () {

    /**
    * Ajaxes the SVG sprite and inserts into the DOM to allow for leveraging of browser caching
    */

    // Request SVG sprite
    var request = new XMLHttpRequest();
    request.open('GET', '/imgs/svg-sprite.svg', true);

    request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
            var data = request.responseText;

            // Create node with response data and insert into DOM
            var div = document.createElement('div');
            div.innerHTML = data;
            document.body.insertBefore(div, document.body.childNodes[0]);
        } else {
            console.log("Couldn't load SVG sprite");

        }
    };

    request.onerror = function () {
        console.log("Couldn't load SVG sprite - connection error");
    };

    request.send();
    function enableCollapse() {
        var collapseLink = document.getElementById('collapseLink');
        var mainContainer = document.getElementById('mainContainer');
        var mainContainerClass = 'main-container-collapse';
        var navContainer = document.getElementById('navContainer');
        var navContainerClass = 'nav-container-collapse';
        if (localStorage.smartSeatCollapsed === 'true') {
            mainContainer.classList.toggle(mainContainerClass);
            navContainer.classList.toggle(navContainerClass);
            collapseLink.classList.toggle('nav-links-item-rotate');
        } else if (localStorage.smartSeatCollapsed === undefined) {
            localStorage.setItem("smartSeatCollapsed", 'false');
        }
        if (collapseLink && mainContainer) {
            collapseLink.addEventListener('click', function (e) {
                this.classList.toggle('nav-links-item-rotate');
                mainContainer.classList.toggle(mainContainerClass);
                navContainer.classList.toggle(navContainerClass);
                if (mainContainer.classList.contains(mainContainerClass) && navContainer.classList.contains(navContainerClass)) {
                    localStorage.smartSeatCollapsed = 'true';
                } else {
                    localStorage.smartSeatCollapsed = 'false';
                }
            });
        }
    }
    enableCollapse();


})();


// WEBPACK FOOTER //
// ./~/source-map-loader!./Frontend/javascript/common/global.ts